module.exports = "/_next/static/images/0000bc195fd494ad52072ea42a853a53-man-sitting-with-notebook@xs-2x.jpg";